<template>
  <div>

     <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
       <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Manufacture" :required="true">
              <b-form-select
                @blur="$v.deviceModel.manufacture_id.$touch"
                :class="{ 'is-invalid': $v.deviceModel.manufacture_id.$error }"
                v-model="deviceModel.manufacture_id"
              >
                <b-form-select-option
                  v-for="m in manufactures"
                  :value="m.id"
                  :key="m.id"
                  >{{ m.description }}</b-form-select-option
                >
              </b-form-select>
              <div
                class="invalid-feedback"
                v-if="!$v.deviceModel.manufacture_id.required"
              >
                Please select manufacture
              </div>
            </form-group>

            <form-group label="Device Type" :required="true">
              <b-form-select
                @blur="$v.deviceModel.device_type_id.$touch"
                :class="{ 'is-invalid': $v.deviceModel.device_type_id.$error }"
                v-model="deviceModel.device_type_id"
              >
                <b-form-select-option
                  v-for="d in deviceTypes"
                  :value="d.id"
                  :key="d.id"
                  >{{ d.description }}</b-form-select-option
                >
              </b-form-select>
              <div
                class="invalid-feedback"
                v-if="!$v.deviceModel.device_type_id.required"
              >
                Please select device type
              </div>
            </form-group>

            <form-group label="Code" :required="true">
              <input
                type="text"
                @blur="$v.deviceModel.code.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.deviceModel.code.$error }"
                v-model="deviceModel.code"
                v-uppercase
              />
              <div
                class="invalid-feedback"
                v-if="!$v.deviceModel.code.required"
              >
                Please enter code
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.deviceModel.code.maximumLength"
              >
                Only 20 characters allowed
              </div>
            </form-group>

            <form-group label="Description" :required="true">
              <input
                type="text"
                @blur="$v.deviceModel.description.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.deviceModel.description.$error }"
                v-model="deviceModel.description"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.deviceModel.description.required"
              >
                Please enter description
              </div>
            </form-group>

            <form-group label="Image">
              <image-upload
                @files-uploaded="
                  deviceModel.image_id = $event;
                  imageUploading = false;
                "
                @files-uploaded-started="imageUploading = true"
                :multiple="false"
                :imageCrop="false"
                :validationState="imageVstate"
                acceptedTypes="image/*"
              />
            </form-group>
          </template>
        </form-base>

       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import deviceModelRepo from '@/api/repos/deviceModelRepo'
import { required,maxLength } from 'vuelidate/lib/validators'
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";


export default {
  components: {
    formBase,
    formGroup,
    imageUpload
  },

  computed: {
    imageVstate: function() {
      return null;
    }
  },

  validations: {
    deviceModel: {
      code: {
        required,        
        maxLength: maxLength(20)
      },
      manufacture_id: {
        required
      },
      device_type_id: {
        required
      },
      description: {
        required,
      },     
    }
  },

  mounted () {
    this.getCreatedData()
    this.getDeviceModel()
  },

  props: ['id'],

  data () {
    return {
      deviceModel: {},
      manufactures: [],
      deviceTypes: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false
    }
  },

  methods: {

     async getCreatedData () {
      try {
        this.loading = true;
        let { data } = await deviceModelRepo.createRelatedData()
        this.deviceTypes = data.device_types
        this.manufactures = data.manufactures
      } catch (error) {
        console.log(error)
      } finally{
        this.loading = false
      }
    },

    async getDeviceModel () {
      try {
        this.loading = true;
        let { data } = await deviceModelRepo.get(this.id)
        this.deviceModel = data.device_model
      } catch (error) {
        console.log(error)
      } finally{
        this.loading = false
      }
    },
   
    async handleSubmit () {
      this.loading = true
      this.submitStatus = 'PENDING'
      this.$v.$touch()
       if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null
      } else {
      try {
          await deviceModelRepo.update(this.id,this.deviceModel)
          this.$emit("deviceModelUpdated");
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
            console.log(this.errors)
               this.$root.$bvToast.toast('Form Errors', {
                title: 'Errors on form data',
                autoHideDelay: 3000,
                variant: 'danger',
            })
          }
        } finally {
          this.loading = false
          this.submitStatus = null
        }
      }
    }
  }
}
</script>

<style></style>
